export default __webpack_public_path__ + "static/media/marriage.df381e30.jpeg";